module.exports = __webpack_public_path__ + "static/media/MrVincentChow.01f84561.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/comp/sub2/MrVincentChow.jpg
// module id = 211
// module chunks = 0